import React, { useEffect, useMemo } from "react";
import { ExpressionProps, VirtualDomNode } from "./type";
import { t } from "../../locale/index";

export default function Expression(props: ExpressionProps) {
  const { expression } = props;

  return (
    <div className="expressionContainer">
      {t("jsonToDomSetter.expression")}: <span className="expression">{expression || <span className="tips">{t('jsonToDomSetter.expressionTip')}</span>}</span>{" "}
    </div>
  );
}
